import index from "./newsList.vue";
export default index;
